<template>
  <div class="modal-body-termo-compra">
    <div
      class="termo-modal-container base animate__animated animate__bounceInDown animate__delay-0.5s"
    >
      <div class="termo-modal-close">
        <CloseIcon @action="closeModal" />
      </div>
      <div class="termo-modal-container1">
        <v-row>
          <v-col cols="12">
            <label class="input-labels">Descrição</label>
            <v-text-field
              hide-details
              v-model="$omnichannel.termo_compra.descricao_pt_BR"
              solo
              class="textinput"
              placeholder="Insira a descrição do termo de compra"
              type="text"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <label class="input-labels">Termo de Compra</label>
            <vue-editor
              id="editor7"
              v-model="$omnichannel.termo_compra.texto_pt_BR"
              :editor-toolbar="customToolbar"
              placeholder="Insira o texto do termo de compra"
              class="termo-editor-input"
            ></vue-editor>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="5">
            <div class="termo-modal-container6 secondary">
              <v-checkbox v-model="$omnichannel.termo_compra.tem_traducao">
                <template v-slot:label>
                  <div>Adicionar traduções</div>
                </template>
              </v-checkbox>
            </div>
          </v-col>
        </v-row>
        <div v-show="$omnichannel.termo_compra.tem_traducao">
          <v-row>
            <v-col cols="12">
              <label class="input-labels">Descrição inglês</label>
              <v-text-field
                hide-details
                v-model="$omnichannel.termo_compra.descricao_en_US"
                solo
                class="textinput"
                placeholder="Insira a descrição do termo de compra"
                type="text"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <label class="input-labels">Termo inglês</label>
              <vue-editor
                id="editor8"
                v-model="$omnichannel.termo_compra.texto_en_US"
                :editor-toolbar="customToolbar"
                placeholder="Insira o texto do termo de compra"
                class="termo-editor-input"
              ></vue-editor>
            </v-col>
            <v-col cols="12">
              <label class="input-labels">Descrição espanhol</label>
              <v-text-field
                hide-details
                v-model="$omnichannel.termo_compra.descricao_es_ES"
                solo
                class="textinput"
                placeholder="Insira a descrição do termo de compra"
                type="text"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <label class="input-labels">Termo espanhol</label>
              <vue-editor
                id="editor9"
                v-model="$omnichannel.termo_compra.texto_es_ES"
                :editor-toolbar="customToolbar"
                placeholder="Insira o texto do termo de compra"
                class="termo-editor-input"
              ></vue-editor>
            </v-col>
          </v-row>
        </div>
        <v-row class="justify-end pa-3">
          <RegistrationActions :fixed="true" :actions="actions" />
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  name: "termoAdd",
  props: ["termoIdx"],
  components: {
    VueEditor,
    RegistrationActions: () =>
      import("@/components/global/RegistrationActions.vue"),
    CloseIcon: () => import("@/components/icons/CloseIcon.vue"),
  },
  data() {
    return {
      actions: [
        {
          name: "Salvar",
          action: () => this.savePolicy(),
        },
        {
          name: "Cancelar",
          action: () => this.closeModal(),
        },
      ],
      customToolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6],
          },
        ],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        ["link"],
        [
          {
            align: "",
          },
          {
            align: "center",
          },
          {
            align: "right",
          },
          {
            align: "justify",
          },
        ],
        [
          {
            list: "ordered",
          },
          {
            list: "bullet",
          },
        ],
        [
          {
            indent: "-1",
          },
          {
            indent: "+1",
          },
        ], // outdent/indent
        // ["blockquote"],
        ["clean"], // remove formatting button
      ],
    };
  },
  methods: {
    cleanPolicyForm() {
      (this.$omnichannel.termo_compra.descricao_pt_BR = ""),
        (this.$omnichannel.termo_compra.descricao_en_US = ""),
        (this.$omnichannel.termo_compra.descricao_es_ES = ""),
        (this.$omnichannel.termo_compra.texto_pt_BR = ""),
        (this.$omnichannel.termo_compra.texto_en_US = ""),
        (this.$omnichannel.termo_compra.texto_es_ES = ""),
        (this.$omnichannel.termo_compra.tem_traducao = false);
    },
    savePolicy() {
      if (this.$omnichannel.cadastro.configsPlusAddEdit == "new") {
        this.$omnichannel.cadastro.termo_compra.push({
          titulo: `<pt_BR>${this.$omnichannel.termo_compra.descricao_pt_BR}</pt_BR><en_US>${this.$omnichannel.termo_compra.descricao_en_US}</en_US><es_ES>${this.$omnichannel.termo_compra.descricao_es_ES}</es_ES>`,
          valor: `<pt_BR>${this.$omnichannel.termo_compra.texto_pt_BR}</pt_BR><en_US>${this.$omnichannel.termo_compra.texto_en_US}</en_US><es_ES>${this.$omnichannel.termo_compra.texto_es_ES}</es_ES>`,
          tem_traducao: this.$omnichannel.termo_compra.tem_traducao,
        });

        this.cleanPolicyForm();

        document.getElementsByClassName(
          "modal-body-termo-compra"
        )[0].style.display = "none";
      } else {
        this.$omnichannel.cadastro.termo_compra[
          this.$omnichannel.termoIdx
        ].titulo = `<pt_BR>${this.$omnichannel.termo_compra.descricao_pt_BR}</pt_BR><en_US>${this.$omnichannel.termo_compra.descricao_en_US}</en_US><es_ES>${this.$omnichannel.termo_compra.descricao_es_ES}</es_ES>`;
        this.$omnichannel.cadastro.termo_compra[
          this.$omnichannel.termoIdx
        ].valor = `<pt_BR>${this.$omnichannel.termo_compra.texto_pt_BR}</pt_BR><en_US>${this.$omnichannel.termo_compra.texto_en_US}</en_US><es_ES>${this.$omnichannel.termo_compra.texto_es_ES}</es_ES>`;
        this.$omnichannel.cadastro.termo_compra[
          this.$omnichannel.termoIdx
        ].tem_traducao = this.$omnichannel.termo_compra.tem_traducao;

        document.getElementsByClassName(
          "modal-body-termo-compra"
        )[0].style.display = "none";

        this.cleanPolicyForm();
      }
    },
    closeModal() {
      document.getElementsByClassName(
        "modal-body-termo-compra"
      )[0].style.display = "none";

      this.cleanPolicyForm();
    },
  },
  watch: {
    "$omnichannel.termo_compra.tem_traducao"(e) {
      if (e) {
        document.getElementsByClassName(
          "termo-modal-container"
        )[0].style.paddingRight = "0px";
        document.getElementsByClassName(
          "termo-modal-container1"
        )[0].style.paddingRight = "0.9375rem";
      }
    },
  },
};
</script>

<style scoped>
.modal-body-termo-compra {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 888;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(250, 204, 204);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
  justify-content: center;
  align-items: center;
}

.termo-editor-input {
  height: auto;
  width: 100%;
  margin-top: 0.375rem;
  margin-bottom: 0.625rem;
  background: #fff;
  overflow: auto;
  border-top-left-radius: 1.25rem;
  border-top-right-radius: 1.25rem;
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  -webkit-box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
.termo-modal-container {
  max-width: 850px;
  max-height: 750px;
  display: flex;
  position: relative;
  align-items: center;
  padding: 0.0825rem;
  border-radius: 1.365rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #eaeaea;
  width: 100%;
}

.termo-modal-close {
  width: 100%;
  height: 5%;
  display: flex;
  justify-content: flex-end;
  padding: 0.325rem;
}

.modal-close-icon {
  width: 24px;
  height: 24px;
  margin-top: 0.1875rem;
  margin-right: 0.375rem;
}

.modal-close-icon:hover {
  width: 26px;
  height: 26px;
  cursor: pointer;
  fill: var(--dl-color-gray-white);
}

.termo-modal-container1 {
  width: 100%;
  height: 85%;
  overflow-y: auto;
  padding: 1rem;
}

.termo-modal-container6 {
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0.125rem 1.5625rem;
  background-color: #c9c9c9;
  border-radius: 0.9375rem;
}

@media (max-width: 1366px) {
  .termo-modal-container {
    width: 720px;
    max-height: 450px;
  }
}
</style>
